import React, {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState
} from 'react';
import { isDevelopment } from 'app/shared/utils/development';
import { Exception } from './Exception';

export type SetException = Dispatch<SetStateAction<Exception | undefined>>;

export interface IExceptionService extends FC {
  useException: () => Exception | undefined;
  useSetException: () => SetException;
}

const ExceptionContext = createContext<Exception | undefined>(undefined);
const SetExceptionContext = createContext<SetException>(() => {});

/**
 * The service of exception.
 *
 * @example
 *
 * <ExceptionService>
 * 	{...}
 * </ExceptionService>
 *
 * const exception = ExceptionService.useException();
 * const setException = ExceptionService.useSetException();
 *
 * setException(new Exception('NOT_FOUND'));
 */
export const ExceptionService: IExceptionService = ({ children }) => {
  const [exception, setException] = useState<Exception | undefined>(undefined);

  if (isDevelopment && exception) {
    console.log('--- exception ---', exception);
  }

  return (
    <SetExceptionContext.Provider value={setException}>
      <ExceptionContext.Provider value={exception}>
        {children}
      </ExceptionContext.Provider>
    </SetExceptionContext.Provider>
  );
};

const useException = () => useContext(ExceptionContext);
const useSetException = () => useContext(SetExceptionContext);

ExceptionService.useException = useException;
ExceptionService.useSetException = useSetException;
